import { useContext } from "react";

import { BoardSettingsContext } from "./BoardSettingsContext";

export function useBoardSettings() {
  const context = useContext(BoardSettingsContext);
  if (!context) {
    throw new Error("useBoardSettings must be used within a BoardSettingsProvider");
  }
  return context;
}
